/**
 * Build identifier — bumped EVERY time we want to confirm a fresh bundle
 * was installed on iOS / Android.  Surfaced in three places:
 *   1. `console.log` on app boot (see `App.js`)
 *   2. Settings → About row (lets the user read it from the device UI)
 *   3. `data-build-id` attribute on <html> (lets QA grep for it via remote
 *      debugging without needing to open the app drawer)
 *
 * Bump format: `<feature>-<short-date>-<seq>`.  Keep it short — it's printed.
 */
export const BUILD_ID = 'fresh-drops-captions-wired-2026-08-a';
